export default __webpack_public_path__ + "static/media/setFigureImage.f52f62b0.gif";